export default {
    props: {
        modalPreventScroll: {
            type: Boolean,
            default: undefined,
            kComposite: 'modal.preventScroll'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/Modal.js